module.exports = __webpack_public_path__ + "img/dashboard.bcf36307.svg";